import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function _360Icon(props: IconProps) {
    return <Icon {...props} iconKey={"360"}/>
}
